import { object, string } from "yup";

export const schema = (t) => {
  return object({
    firstName: string().trim().required(t("validation:required-field")),
    lastName: string().trim().required(t("validation:required-field")),
    email: string()
      .required(t("validation:required-field"))
      .matches(
        // /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
        t("validation:invalid-email"),
      ),
    roleName: string().required(t("validation:required-field")),
    phoneNumber: string()
      .required(t("validation:required-field"))
      .transform((value) => value.replace(/[-\s]/g, ""))
      .test("hasExactDigits", t("validation:invalid-phone-number"), (value) => {
        if (!value) { return false };
        const digitCount = value.length;

        // Ensures that exactly 10 digits are present and only numbers are entered.
        return digitCount === 10 && /^\d{10}$/.test(value);
      })
      .trim(),
  });
};
